import { createPortal } from "react-dom"

/** Asked on Save: apply this week's task/assignee edits to future weeks (the
 *  recurring template), or save just this week. */
export function SaveDialog({
  busy,
  onCancel,
  onSave,
}: {
  busy: boolean
  onCancel: () => void
  onSave: (applyToFuture: boolean) => void
}) {
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm space-y-3 rounded-xl bg-white p-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-sm font-semibold text-slate-800">Save changes</h3>
        <p className="text-xs text-slate-500">
          Apply this week's <b>task and assignee</b> changes to future weeks too? This updates the
          recurring template so upcoming weeks match. Completion checkmarks reset each week.
        </p>
        <div className="flex flex-wrap items-center justify-end gap-2 pt-1">
          <button
            onClick={onCancel}
            disabled={busy}
            className="rounded-lg px-3 py-1.5 text-xs font-semibold text-slate-500 transition hover:bg-slate-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(false)}
            disabled={busy}
            className="rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50"
          >
            This week only
          </button>
          <button
            onClick={() => onSave(true)}
            disabled={busy}
            className="rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-emerald-700 disabled:opacity-50"
          >
            {busy ? "Saving…" : "Apply to future weeks"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
